// Modify following two value for local development.
export const config = {
  // host: 'https://rint.santanderuk.pre.corp',
  // host: 'https://secure.cahoot.pre.corp',
  // 'host': 'http://rint.santanderuk.local.corp',
  // "authenticator-context": "/olb/app/dummy-auth",
  'host': '',
  'authenticator-context': '/olb/app/authenticator',
  CONST_AUTHENTICATOR_CONTEXT: 'authenticator-context'
};

// Fixed configuration. Do not modify it.
export const URL = {
  host: config['host'],
  externalSantander: 'https://www.santander.co.uk',
  externalSecureCahoot: 'https://secure.cahoot.com',
  externalCahoot: 'https://www.cahoot.com',
  bksCookieName: 'NewUniversalCookie',
  authorizeEndpoint: config[config.CONST_AUTHENTICATOR_CONTEXT] + '/authorize',
  customerProfileUrl:
    '/sanuk/internal/A/olb/api/customer-accounts/customer-profile/{{uid}}/brand',
  revokeEndpoint: config[config.CONST_AUTHENTICATOR_CONTEXT] + '/revoke',
  revokeSessionUrl:
    config[config.CONST_AUTHENTICATOR_CONTEXT] + '/revoke-session?domain={{domain}}',
  loggingServiceUrl: '/olb/app/logging/v1/message',
  loggingLevel: 'info',
  sendSecureMessageUrl: '/EBAN_Accounts_ENS/channel.ssobto?dse_operationName=contentTemplate&opCode=00000078&iurl=%2FMSEABB_ENS%2Fchannel.ssobto%3Fdse_operationName%3DOP_SecureMessages%26obtenerMensaje_E.esContactUs%3DS',
};
